export const RAWG_API = "https://api.rawg.io/api";
export const API_KEY = "f9d18241ce6e4e9d9d76f31d28edf0a7";
export const DOMAIN_URL = "https://";
